import React from 'react';
import { func, string } from 'prop-types';
import { Chip } from '@mui/material';

// Styles
import { useTheme } from '@mui/material/styles';
import { containerStyles } from './FilterIdentifier.styles';

const FilterIdentifier = ({ label, name, resetSingleFilter, value }) => {
  const theme = useTheme();
  return (
    <Chip
      label={`${label}: ${value}`}
      onDelete={() => resetSingleFilter(name)}
      sx={{ ...containerStyles(theme) }}
      variant="outlined"
    />
  );
};

FilterIdentifier.propTypes = {
  label: string.isRequired,
  name: string.isRequired,
  resetSingleFilter: func.isRequired,
  value: string.isRequired,
};

export default FilterIdentifier;
